export default "__VITE_ASSET__BZHgbNmM__"